export default __webpack_public_path__ + "static/media/Flag_of_South_Africa.a4b4ad96.svg";